import type { ListClaimAcquisitions } from "@upclaim/sdk/src/data-contracts";

export type FamilyClaimAcquisition = ListClaimAcquisitions["families"][number];
export type AcquisitionStep = FamilyClaimAcquisition["step"];

/** Status badge copy + dot color — port of the step badges of AcquisitionHistory.vue. */
export function getAcquisitionStepBadge(step: AcquisitionStep): { label: string; dotClass: string } | null {
  switch (step) {
    case "EXPIRED":
      return { label: "Expiré", dotClass: "fill-gray-500" };
    case "DECLINED":
      return { label: "Décliné", dotClass: "fill-red-500" };
    case "REJECTED_PRE_EXISTING_CLAIM":
      return { label: "Démarche déjà engagée ailleurs", dotClass: "fill-red-500" };
    case "CONFIRM":
      return { label: "(1/3) Attente confirmation incident", dotClass: "fill-yellow-500" };
    case "EXPENSES":
      return { label: "(2/3) En attente des dépenses", dotClass: "fill-blue-500" };
    case "SIGNATURE":
      return { label: "(3/3) Attente Signature", dotClass: "fill-indigo-500" };
    case "COMPLETE":
      return { label: "Cession Signée", dotClass: "fill-green-600" };
    default:
      return null;
  }
}

/** Colored ring classes of the step icon circle — port of the class bindings of AcquisitionHistory.vue. */
export function getAcquisitionStepCircleClasses(step: AcquisitionStep): string {
  switch (step) {
    case "EXPIRED":
      return "text-gray-700 border-gray-100 ring-gray-50";
    case "CONFIRM":
      return "text-amber-700 border-stone-100";
    case "EXPENSES":
      return "text-blue-700 border-blue-100";
    case "SIGNATURE":
      return "text-indigo-700 border-indigo-200 ring-indigo-100";
    case "COMPLETE":
      return "text-green-700 border-green-100";
    default:
      return "";
  }
}

/**
 * Passenger display name — `firstName lastNAME` with spaces dashed (Vue template logic).
 * Both parts are nullable in database, so a half-known passenger renders its known half
 * instead of a stray space.
 */
export function getAcquisitionPassengerName(user: {
  firstName: string | null;
  lastName: string | null;
}): string {
  const firstName = user.firstName?.split(" ").join("-") ?? "";
  const lastName = user.lastName?.split(" ").join("-").toUpperCase() ?? "";

  return [firstName, lastName].filter(Boolean).join(" ");
}

/** Postmark outbound activity URL for an email address (Upclaim only). */
export function generatePostmarkUrl(email: string): string {
  const encodedEmail = encodeURIComponent(email);
  return `https://account.postmarkapp.com/servers/6368441/streams/outbound/addresses/${encodedEmail}`;
}
